import type { Event as UserEvent } from "@tandemdiabetes/sugarmate-api-react-client"
import type { MangoQuery } from "rxdb"

const defaultSelector = {}
const defaultSort = [{ started_at: "desc" as const }]

// add "deleted_at" and "account_id" selector to event query
export function createEventQueryObject(
  accountId: number | undefined,
  {
    selector,
    sort,
    limit,
  }: MangoQuery<UserEvent>,
): MangoQuery<UserEvent> {
  return {
    selector: {
      ...(accountId ? { account_id: { $eq: accountId } } : {}),
      deleted_at: { $eq: null },
      ...(selector ?? defaultSelector),
    },
    sort: (sort ?? defaultSort),
    limit,
  }
}
